import { Invoice } from '../../models/InvoiceModel';

/**
 * Invoice アクションボタンのコールバック関数の型定義
 */
export interface InvoiceActionCallbacks {
  /** 却下処理のコールバック */
  onReject?: (invoice: Invoice) => void;
  /** 保留処理のコールバック */
  onHold?: (invoice: Invoice) => void;
  /** 再提出処理のコールバック */
  onResubmit?: (invoice: Invoice) => void;
  /** 受領処理のコールバック */
  onReceive?: (invoice: Invoice) => void;
}

/**
 * Invoice の状態定数
 */
export const INVOICE_STATES = {
  /** 確認中 */
  REVIEWING: 0,
  /** 受領済み */
  RECEIVED: 1,
  /** 却下 */
  REJECTED: 2,
  /** 保留 */
  ON_HOLD: 3,
  /** 再提出 */
  RESUBMISSION: 4,
} as const;

/**
 * ユーザーロール定数
 */
export const USER_ROLES = {
  /** 受領権限 */
  RECEIVER: 1,
} as const;

/**
 * Invoice の状態を判定するヘルパー関数
 */
export class InvoiceStateChecker {
  /**
   * 受領権限があるかチェック
   */
  static hasReceivePermission(invoice: Invoice): boolean {
    return invoice.to_assignment?.role === USER_ROLES.RECEIVER;
  }

  /**
   * 確認状態かチェック
   * 条件: 確認中、保留中、再提出中
   */
  static isInReviewState(invoice: Invoice): boolean {
    return (
      invoice.state === INVOICE_STATES.REVIEWING ||
      invoice.state === INVOICE_STATES.RESUBMISSION ||
      invoice.state === INVOICE_STATES.ON_HOLD
    );
  }

  /**
   * アクションボタンを表示すべきかチェック
   */
  static shouldShowActionButtons(invoice: Invoice): boolean {
    return this.hasReceivePermission(invoice) && this.isInReviewState(invoice);
  }
}
